"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyRowData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const TableBodyRow_1 = require("./TableBodyRow");
exports.emptyRowData = {
    authority: '',
    downloadUrl: '',
    fileType: '',
    languages: [''],
    name: '',
    rowId: '',
    size: '',
    type: '',
    updated: '',
    updatedTimestamp: 0,
    status: { title: '', type: 0 },
};
const TableBodyEmpty = ({ columns, dictionary, isDesktop }) => {
    return ((0, jsx_runtime_1.jsx)("tbody", { tabIndex: -1, className: "screen-reader-only hidden", children: (0, jsx_runtime_1.jsx)(TableBodyRow_1.TableBodyRow, { rowInfo: exports.emptyRowData, columns: columns, dictionary: dictionary, isDesktop: isDesktop, clickableElementsTabIndex: -1 }) }));
};
exports.default = TableBodyEmpty;
